import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: string;
  title: string;
  titleEn: string;
  year: number;
  genre: string;
  rating: number;
  posterUrl: string;
  isNew?: boolean;
  isHot?: boolean;
  category: 'movie' | 'tv';
  episodes?: string;
  tags?: string[];
}

export default function MovieCard({
  id,
  title,
  titleEn,
  year,
  genre,
  rating,
  posterUrl,
  isNew,
  isHot,
  category,
  episodes,
  tags,
}: MovieCardProps) {
  const detailPath = category === 'movie' ? `/detail/movie/${id}` : `/detail/tv/${id}`;

  return (
    <Link
      to={detailPath}
      className="group block rounded-lg overflow-hidden bg-background-800/50 hover:bg-background-800 transition-all duration-300"
      data-product-shop
    >
      <div className="relative overflow-hidden aspect-[2/3]">
        <img
          src={posterUrl}
          alt={title}
          title={`${title} - 奇优影院高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent"></div>

        {(isNew || isHot) && (
          <div className="absolute top-3 left-3 flex gap-2">
            {isNew && (
              <span className="px-2 py-0.5 bg-primary-500 text-background-950 text-xs font-bold rounded-md whitespace-nowrap">NEW</span>
            )}
            {isHot && (
              <span className="px-2 py-0.5 bg-accent-500 text-background-950 text-xs font-bold rounded-md whitespace-nowrap">热播</span>
            )}
          </div>
        )}

        <div className="absolute top-3 right-3">
          <span className="px-2 py-0.5 bg-background-950/70 backdrop-blur-sm text-accent-400 text-xs font-bold rounded-md whitespace-nowrap">
            {rating}
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="text-foreground-950 font-bold text-base leading-tight mb-1 whitespace-nowrap overflow-hidden text-ellipsis">{title}</h3>
          <p className="text-foreground-500 text-xs">{titleEn}</p>
          <div className="flex items-center gap-2 mt-2">
            <span className="text-foreground-600 text-xs">{year}</span>
            <span className="text-foreground-700 text-xs">&middot;</span>
            <span className="text-foreground-600 text-xs">{genre}</span>
            {episodes && (
              <>
                <span className="text-foreground-700 text-xs">&middot;</span>
                <span className="text-foreground-600 text-xs">{episodes}</span>
              </>
            )}
          </div>
          {tags && tags.length > 0 && (
            <div className="flex flex-wrap gap-1 mt-2">
              {tags.slice(0, 2).map((tag) => (
                <span key={tag} className="px-1.5 py-0.5 bg-primary-500/20 text-primary-300 text-[10px] rounded whitespace-nowrap">
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}